<template>
  <section>
    <h1 className="track-in">
      Error: 404
    </h1>
    <p>No content found for url <code>{{ where }}</code>.</p>
  </section>
</template>
<script>
export default {
  name: 'Error404Page',
  data () {
    return {
      where: window.location.href
    }
  }
};
</script>
